import { EntityType } from '@frontend/common';
import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import React from 'react';

const ID = 'group-type-select';

export const GroupTypeSelectV2 = (props: Omit<SelectInputV2Props<EntityType>, 'options'>) => {
    const options = [EntityType.USER_GROUP, EntityType.EQUIPMENT_GROUP, EntityType.PRODUCT_GROUP, EntityType.PRODUCT_CATEGORY, EntityType.QUESTIONNAIRE];
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            label={props.label || 'Type'}
            options={options.map((c) => ({ value: c, label: c.toString() }))}
            value={props.value}
            onSelect={props.onSelect}
        />
    );
};
